// Services / "What I Do" section content.
// Each service has a plain-text `desc`. If the desc contains a link, express
// the link separately in `link` so both the React component and the llms
// generator can render it appropriately (the component inlines an <a>, the
// generator emits Markdown `[text](url)`).
module.exports = [
  {
    name: "Cloud Architecture",
    desc:
      "Architecting mission-critical systems across financial services, payments, digital marketplaces, SaaS platforms, and high-growth startups. From national-scale infrastructure to early-stage product design.",
    icon: "fas fa-cloud",
  },
  {
    name: "Resilience & Operational Excellence",
    desc:
      "Designing systems that increase time between failures. 3x AWS re:Invent speaker on operational excellence and resilient systems with consistently high audience satisfaction.",
    icon: "fas fa-shield-alt",
  },
  {
    name: "Platform Modernisation",
    desc:
      "Transforming legacy platforms from manual deployments to modern CI/CD operations, improving availability, enabling faster delivery, and positioning products for acquisition.",
    icon: "fas fa-rocket",
  },
  {
    name: "Financial Services & Payments",
    desc:
      "Advising Australia's largest financial services organisations on cloud transformation, cybersecurity, and regulatory compliance across payments, lending, and digital banking.",
    icon: "fas fa-university",
  },
  {
    name: "Team Building & Leadership",
    desc:
      "Building technical communities of 200+ members across 50+ departments, mentoring engineers and team leads, and creating cultures of ownership and continuous improvement.",
    icon: "fas fa-users",
  },
  {
    name: "AI/ML & Intelligent Automation",
    desc:
      "Delivering production AI/ML systems with measurable business outcomes. From GenAI strategy and governance to intelligent document processing and AI-assisted software development lifecycles, helping organisations move from experimentation to production.",
    icon: "fas fa-brain",
  },
  {
    name: "Writing & Speaking",
    // {blog} is substituted with the link text by both renderers.
    desc:
      "Sharing insights on cloud architecture and best practices at {blog} and industry conferences worldwide.",
    icon: "fas fa-pen-fancy",
    link: {
      placeholder: "{blog}",
      text: "123cloud.st",
      url: "https://www.123cloud.st",
      analyticsEvent: "Visit 123cloud.st Services",
    },
  },
];
